import React, { useEffect, useMemo, useState } from "react";
import Container from "../../components/Layout/Container";
import ContentBlock from "../../components/Layout/ContentBlock";
import HamlSnippet from "../../components/globals/HamlSnippet";

function ProductVariantGlobalRulesPage({ match }) {

  return (
    <Container
          location={{
            locationName: "Product Variant Global Rules",
            locationUrl: match.url,
          }}
        >
        <HamlSnippet url="/front/products/product_variant_global_rules" />
    </Container>
  );
}

export default ProductVariantGlobalRulesPage;